import { useQuery } from "@tanstack/react-query";
import { useCustomers } from "../customers/useCustomers";
import { useProducts } from "../admin/products/useProducts";
import { useProviders } from "../admin/providers/useProviders";
import { listCosts } from "./costApi";
import type { Cost } from "./costTypes";

export const useCosts = (params: { from: string; to?: string; showPaid: boolean }) => {
  const { data, isLoading: areCostsLoading } = useQuery({
    queryKey: ["costs", params],
    queryFn: ({ signal }) => listCosts(params, signal),
  });
  const { providers, isLoading: areProvidersLoading } = useProviders();
  const { products, isLoading: areProductsLoading } = useProducts();
  const { customers } = useCustomers();
  const costs: Cost[] = data
    ? data.map((c) => ({
        id: c.id,
        bookingNumber: c.bookingNumber,
        status: c.status,
        provider: { id: c.provider.id, name: providers.find((p) => p.id === c.provider.id)?.name ?? "" },
        customer: { id: c.order.customerId, name: customers?.find((cus) => cus.id === c.order.customerId)?.name ?? "" },
        order: {
          id: c.order.id,
          name: c.order.name,
          currency: c.order.currency,
          status: c.order.status,
          start: c.order.start,
          isHistorical: c.order.isHistorical,
          price: c.order.price,
          products: c.order.productIds.map((id) => ({ id, name: products.find((p) => p.id === id)?.name ?? "" })),
        },
        totalAmount: c.totalAmount,
        date: c.date,
        invoices: c.invoices,
        currency: c.currency,
        files: c.files,
        notes: c.notes,
      }))
    : [];

  return {
    costs,
    isLoading: areCostsLoading || areProvidersLoading || areProductsLoading,
  };
};
